import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import "../components/CSS/Reports.css";
import MasterLayout from "../masterLayout/MasterLayout";
export default function Reports() {
  return (
    <div>
      {" "}
      <MasterLayout>
        <Breadcrumb title="Reports" />
        <div className="Reports"></div>
      </MasterLayout>
    </div>
  );
}
